import React from "react";
import moment from "moment";
import { getField, formatDate } from "../../util/DynamicItemUtils";

export default function OtherUpdate({ item }: any) {
  const dateParsingFormat = "YYYY-MM-DDTHH:mm:ssZ";
  const dateDisplayFormat =
    getField(item, "displayarticledate") &&
    formatDate(getField(item, "displayarticledate"));

  return (
    <div>
      <p className="lead-text-lt">Other Update</p>
      <h3>
        <a href={getField(item, "pageurl")}>{getField(item, "title")}</a>
      </h3>
      <div className="hawk-row">
        {getField(item, "displayarticledate") && (
          <div className="hawk-column">
            <div className="lead-text-lt">Date</div>
            <div className="lead-text-st">
              {getField(item, "displayarticledate")
                ? moment(
                    getField(item, "displayarticledate"),
                    dateParsingFormat
                  ).format(dateDisplayFormat)
                : null}
            </div>
          </div>
        )}
      </div>
      <a href={getField(item, "pageurl")} className="hawk-read-more">
        Read More
      </a>
    </div>
  );
}
